module.exports = __webpack_public_path__ + "static/media/3.704a2380.svg";